// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Bbde6","brand":"Header_brand__Fm-E5","adminName":"Header_adminName__4yvwp"};